import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrows-right",
  "use": "icon-arrows-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrows-right\"><path d=\"M347.036 140.83L715.26 514.946 341.144 883.17c-11.783 11.783-11.783 29.458 0 41.241 11.783 11.783 29.458 11.783 41.241 0l394.736-388.845c11.784-11.783 11.784-29.458 0-41.24L388.277 99.588c-11.784-11.783-29.458-11.783-41.241 0-11.784 11.783-11.784 29.458 0 41.241z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrows-right.svg
// module id = sGpw
// module chunks = 65